import {
  Button,
  Center,
  Flex,
  Heading,
  HStack,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import ReachCTALogo from "assets/icons/medium/reach-cta-logo.svg?react";

export function ReachMarketingCta() {
  // TODO: handleOnClick for agent contact
  const handleOnClick = () => {
    return null;
  };
  return (
    <Center h={{ base: "378px", md: "578px" }} p={{ base: "10px", md: "80px" }}>
      <VStack gap={{ base: "36px", md: "56px" }}>
        <HStack gap={{ base: 2, md: 4 }}>
          <Heading
            size={{ base: "lg", md: "3xl" }}
            fontWeight={700}
            whiteSpace={"nowrap"}
          >
            Boost your listings with
          </Heading>
          <Flex align={"center"} justify={"center"}>
            <Image
              as={ReachCTALogo}
              w={{ base: "100px", md: "150px" }}
              h={"auto"}
              mb={1}
              color={"#FFFF"}
            />
          </Flex>
        </HStack>

        <Text fontSize={"lg"} textAlign={"center"}>
          Reach thousands of buyers, sellers and promote your listing in a few
          clicks. Through the 26+ real estate ads formats Rex Reach creates for
          Facebook, Instagram and millions of websites through the Google
          display network.
        </Text>
        <Button variant={"solid"} colorScheme={"gray"} onClick={handleOnClick}>
          Contact agent
        </Button>
      </VStack>
    </Center>
  );
}
